import * as API from './apis';
import Swal from 'sweetalert2';
import { RootState } from '../../domain/models/RootState';
import { createAsyncThunkApp } from '../hooks';
import { CreateLoanP2PRequest } from './models/dtos/CreateLoanP2PRequest';
import { AccepLoanP2Prequest } from './models/dtos/AcceptLoanP2PRequest';
import { CancelLoanP2Prequest } from './models/dtos/CancelLoanP2PRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

const errorTextTransfer = (action: string) =>
  `No fue posible ${action} la transferencia, intente de nuevo. Si el problema persiste, contacte a un administrador.`;
const errorTitleTransfer = (action: string) =>
  `'Hubo un error al ${action} transferencia',`;

export const createLoanP2P = createAsyncThunkApp<any, CreateLoanP2PRequest>(
  'Loan/createLoanP2P',
  async (loanP2P: CreateLoanP2PRequest, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res = await API.createLoanP2P(auth.token, loanP2P);
      if (res.status === 200) {
        Swal.fire(
          'Correcto',
          'Nueva transferencia registrada con éxito.',
          'success'
        );
        return true;
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: errorTitleTransfer('crear'),
        text: errorTextTransfer('crear'),
      });
      throw error;
    }
  }
);

export const acceptLoanP2P = createAsyncThunkApp<any, AccepLoanP2Prequest>(
  'Loan/acceptLoanP2P',
  async ({ transfer_id, keys }: AccepLoanP2Prequest, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res = await API.acceptLoansP2P(auth.token, transfer_id, keys);
      if (res.status === 200) {
        Swal.fire(
          'Correcto',
          'Se han registrado los nuevos prestamos.',
          'success'
        );
        return true;
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: errorTitleTransfer('aceptar'),
        text: errorTextTransfer('aceptar'),
      });
      throw error;
    }
  }
);

export const cancelLoanP2P = createAsyncThunkApp<any, CancelLoanP2Prequest>(
  'Loan/cancelLoanP2P',
  async ({ transfer_id }: CancelLoanP2Prequest, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res = await API.cancelLoansP2P(auth.token, transfer_id);
      if (res.status === 200) {
        Swal.fire(
          'Correcto',
          'La transferencia fue cancelada con éxito.',
          'success'
        );
        return true;
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: errorTitleTransfer('cancelar'),
        text: errorTextTransfer('cancelar'),
      });
      throw error;
    }
  }
);

export const getAllLoansP2P = createAsyncThunkApp<any, any>(
  'LoansP2P/getAllLoans',
  async ({ filter, pagination }: any, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      return await API.getAllLoans(auth.token, { filter, pagination });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

//este no
export const getUserLoanP2P = createAsyncThunk<any, any, { state: RootState }>(
  'LoansP2P/getUserLoan',
  async ({ filter, pagination }: any, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      return await API.getUserLoanP2P(auth.token, { filter, pagination });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const getSessionLoansP2P = createAsyncThunkApp<any, void>(
  'LoansP2P/getSessionLoans',
  async (_: void, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      const res: any = await API.getSessionLoans(auth.token);
      return res.data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos del usuario',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);
